<template>
  <div class="ma-4">
    <v-row v-if="showGraphs" class="ma-0">
      <!-- SNRVERTICAL Component -->
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="6"
        xl="6"
        class="pa-0 pr-sm-2 pr-md-2 pr-lg-2 pr-xl-2"
      >
        <v-sheet
          :class="xs ? 'card-dialogs-graph-wop' : 'card-dialogs-graph'"
          class="mb-4"
          color="bgtopology"
        >
          <SingleChart
            v-if="allArrayCambiumData.snrver.length !== 0"
            :name="'SNRVertical'"
            :first-array="allArrayCambiumData.snrver"
            title="SNRVertical"
            :color="COLOR.single"
          />
          <v-sheet v-else class="text-center" color="transparent">
            <Prog_circular />
          </v-sheet>
        </v-sheet>
      </v-col>

      <!-- SNRHORIZONTAL Component -->
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="6"
        xl="6"
        class="pa-0 pl-sm-2 pl-md-2 pl-lg-2 pl-xl-2"
      >
        <v-sheet
          :class="xs ? 'card-dialogs-graph-wop' : 'card-dialogs-graph'"
          class="mb-4"
          color="bgtopology"
        >
          <SingleChart
            v-if="allArrayCambiumData.snrhor.length !== 0"
            :name="'SNRHorizontal'"
            :first-array="allArrayCambiumData.snrhor"
            title="SNRHorizontal"
            :color="COLOR.single"
          />
          <v-sheet v-else class="text-center" color="transparent">
            <Prog_circular />
          </v-sheet>
        </v-sheet>
      </v-col>
    </v-row>

    <!-- LINKRADIOHORIZONTAL Component -->
    <v-sheet
      v-if="showGraphs"
      :class="xs ? 'card-dialogs-graph-wop' : 'card-dialogs-graph'"
      class="mb-4"
      color="bgtopology"
    >
      <SingleChart
        v-if="allArrayCambiumData.radioh.length !== 0"
        :name="'RXHorizontal'"
        :first-array="allArrayCambiumData.radioh"
        title="RXHorizontal"
        :color="COLOR.single"
      />
      <v-sheet v-else class="text-center" color="transparent">
        <Prog_circular />
      </v-sheet>
    </v-sheet>

    <!-- LINKRADIOVERTICAL Component -->
    <v-sheet
      v-if="showGraphs"
      :class="xs ? 'card-dialogs-graph-wop' : 'card-dialogs-graph'"
      class="mb-4"
      color="bgtopology"
    >
      <SingleChart
        v-if="allArrayCambiumData.radiov.length !== 0"
        :name="'RXVertical'"
        :first-array="allArrayCambiumData.radiov"
        title="RXVertical"
        :color="COLOR.single"
      />
      <v-sheet v-else class="text-center" color="transparent">
        <Prog_circular />
      </v-sheet>
    </v-sheet>

    <!-- THROUGHPUT Component -->
    <v-sheet
      v-if="showGraphs"
      :class="xs ? 'card-dialogs-graph-wop' : 'card-dialogs-graph'"
      class="mb-4"
      color="bgtopology"
    >
      <SingleChart
        v-if="allArrayCambiumData.throug.length !== 0"
        :name="'throughput'"
        :first-array="allArrayCambiumData.throug"
        title="throughput"
        :color="COLOR.single"
      />
      <v-sheet v-else class="text-center" color="transparent">
        <Prog_circular />
      </v-sheet>
    </v-sheet>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from "vuetify";
const { xs } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from "vue-i18n";
const { t } = useI18n();

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from "vuex";
const store = useStore();

/********************************
 ********** COMPONENTS **********
 *******************************/
import Prog_circular from "@/components/PrincipalComponents/Prog_circular.vue";
import SingleChart from "@/components/SmartLink/charts/SingleChart.vue";

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS } from "@/constants/labels";
import { COLOR } from "@/constants/colors";

/********************************
 *********** SERVICES ***********
 *******************************/
import { getCambiumDataByIp } from "@/services/Smartlink/Graphs";

const props = defineProps({
  title: { required: true },
  ip: { required: true, type: String },
});

const allArrayCambiumData = ref({
  radioh: [],
  radiov: [],
  throug: [],
  snrhor: [],
  snrver: [],
});

/**
 * Si trae valores la API, muestra su grafico.
 */
const showGraphs = ref(true);

/**
 * get All Data from API to Graph (linkradiohoriz, linkradiovert, throughput, snr)
 */
async function getDataGraph(type: string) {
  const params = {
    ip: props.ip,
    type: type,
  };
  const allData = await getCambiumDataByIp(params);

  if (allData.status === 400) {
    showGraphs.value = allData.showGraphs;
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    showGraphs.value = allData.showGraphs;
    allArrayCambiumData.value.radioh = allData.data.radioh;
    allArrayCambiumData.value.radiov = allData.data.radiov;
    allArrayCambiumData.value.throug = allData.data.throug;
    allArrayCambiumData.value.snrhor = allData.data.snrhor;
    allArrayCambiumData.value.snrver = allData.data.snrver;
  }
}

onMounted(async () => {
  getDataGraph("cambium_data");
});
</script>
